<template>
  <el-dialog
    v-model="dialogVisible"
    :width="width + 'px'"
    @open="handleOpen"
    @close="handleClose"
    :modal="false"
    :append-to-body="true"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    :title="title"
    class="dragdialog"
    modal-class="dragdialogwrap"
    draggable
    ref="dialogRef"
  >
    <div class="dialog-body">
      <slot></slot>
    </div>
    <div class="resize-handle" @mousedown="handleResizeMouseDown"></div>
  </el-dialog>
</template>

<script setup>
import { ref, reactive, onMounted, onBeforeUnmount, computed, defineProps } from 'vue';

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  visible: {
    type: Boolean,
    default: false
  },
  width: {
    type: Number,
    default: 450,
  },
  defaultPosition: {
    type: Object,
    default: () => ({ top: 130, left: 30 })
  }
})

const emits = defineEmits(['update:visible'])

const state = reactive({
  isResizing: false,
  startX: 0,
  startY: 0,
  startWidth: 0,
  startHeight: 0,
  dialogWidth: 0,
  dialogHeight: 0
})

const dialogRef = ref()
const dialogVisible = computed(() => props.visible)

const getDialogDom = () => document.querySelector('.dragdialog')

const handleOpen = () => {
  console.log('cdialogRef', dialogRef)
  const targetDom = getDialogDom()
  targetDom.style.top = `${props.defaultPosition.top}px`
  targetDom.style.left = `${props.defaultPosition.left}px`
}

const handleClose = () => {
  emits('update:visible', false)
}

const handleMouseMove = (event) => {
  console.log(state.isResizing)
  if (state.isResizing) {
    const targetDom = getDialogDom()
    const dx = event.clientX - state.startX
    const dy = event.clientY - state.startY
    const maxWidth = window.innerWidth
    const maxHeight = window.innerHeight - props.defaultPosition.top - 20
    targetDom.style.width = Math.min(state.startWidth + dx, maxWidth) + 'px'
    targetDom.style.height = Math.min(state.startHeight + dy, maxHeight) + 'px'
  }
}

const handleMouseUp = () => {
  state.isResizing = false
  document.removeEventListener('mousemove', handleMouseMove)
  document.removeEventListener('mouseup', handleMouseUp)
}

const handleResizeMouseDown = (event) => {
  const targetDom = getDialogDom()
  state.isResizing = true
  state.startX = event.clientX
  state.startY = event.clientY
  state.startWidth = targetDom.clientWidth
  state.startHeight = targetDom.clientHeight
  document.addEventListener('mousemove', handleMouseMove)
  document.addEventListener('mouseup', handleMouseUp)
}

onMounted(() => {
  document.addEventListener('mouseup', handleMouseUp);
});

onBeforeUnmount(() => {
  document.removeEventListener('mouseup', handleMouseUp);
});
</script>

<style lang="scss">
.dragdialogwrap {
  position: relative !important;
  .el-overlay-dialog {
    position: relative !important;
  }
}
.el-dialog.dragdialog {
  position: fixed;
  z-index: 3000;
  margin: 0;
  .el-dialog__body {
    height: calc(100% - 61px);
    max-height: calc(100vh - 220px);
    overflow: auto;
    box-sizing: border-box;
  }
}
</style>
<style scoped>
.dialog-body {
  padding: 0;
}

.close-btn {
  margin-left: auto;
}

.resize-handle {
  width: 10px;
  height: 10px;
  background-color: transparent;
  position: absolute;
  right: 0;
  bottom: 0;
  cursor: se-resize;
}
</style>